// BM-7639 — Stacked coloured-pill totals rendered above a column header.
// 'all' value comes from Redux (backend-supplied); 'active' and 'selected' are computed
// client-side from currently-loaded rows and passed in via `clientTotals`.

import React from 'react';
import { useSelector } from 'react-redux';
import { roundOff } from '../../../../../Components/helper';
import { SCOPE_KEYS } from './scopeColors';

const formatTotal = (value, isInteger) => {
  if (typeof value !== 'number' || !Number.isFinite(value)) return '';
  return isInteger ? String(roundOff(value, 0)) : String(roundOff(value, 2));
};

function ColumnTotalsDisplay({ columnId, subType, clientTotals }) {
  const entry = useSelector((state) => state.ProductListData?.columnTotals?.[columnId]);
  if (!entry || !Array.isArray(entry.scopes) || entry.scopes.length === 0) return null;

  const isInteger = subType === 'integer';

  return (
    <div className="column-totals-pills">
      {SCOPE_KEYS.filter((s) => entry.scopes.includes(s)).map((scope) => {
        const raw = scope === 'all' ? entry.values?.all : clientTotals?.[scope];
        const isLoading = scope === 'all' && entry.loading && raw === undefined;
        const display = isLoading ? '…' : formatTotal(raw, isInteger);
        if (display === '') return null;
        return (
          <span
            key={scope}
            className={`column-totals-pill column-totals-pill--${scope}`}
            title={`${scope}: ${display}`}
          >
            {display}
          </span>
        );
      })}
    </div>
  );
}

export default ColumnTotalsDisplay;
